// import {  } from "react-router-dom";
import { useEffect, useLayoutEffect } from "react";
import { useNavigate } from "react-router";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import LoginInsert from "../components/login/LoginInsert";
import LoginPageNavbar from "../components/login/LoginPageNavbar";
import SiteDescription from "../components/login/SiteDesc";
import { TOGGLE_MODE } from "../redux/actions/constants";

const Login = () => {
    const navigate = useNavigate();
    const { isDarkMode, userInfo } = useSelector(
        (state) => state.persistedReducer,
        (oldValue, newValue) => {
            if (
                oldValue.isDarkMode !== newValue.isDarkMode ||
                oldValue.userInfo.accountInfo.accountName !==
                    newValue.userInfo.accountInfo.accountName
            ) {
                return false;
            }
            return true;
        }
    );

    const dispatch = useDispatch();

    useEffect(() => {
        if (userInfo.accountInfo.accountName.trim() !== "") {
            navigate("/");
        }
    }, []);
    useLayoutEffect(() => {
        !isDarkMode && dispatch({ type: TOGGLE_MODE });
    }, []);

    return (
        <div className="w-full min-h-screen flex flex-col ">
            <LoginPageNavbar />
            <div className="mt-12 min-h-screen flex flex-col lg:flex-row ">
                <SiteDescription />
                <LoginInsert isDarkMode={isDarkMode} />
            </div>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Login</title>
            </Helmet>
        </div>
    );
};

export default Login;
